// vendors
import { useEffect } from "react";
import { MantineProvider } from "@mantine/core";
import { useLocalStorage, useSetState } from "@mantine/hooks";
import { NotificationsProvider } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import ErrorBoundary from "./components/ErrorBoundary";
// utils
import Router from "./routes";
import "./App.css";

function App() {
  const [theme, setTheme] = useSetState({
    // defaultRadius: 0,
    colors: {
      brand: [
        "#FEF5DA",
        "#FEEEC1",
        "#FDE18F",
        "#FDD769",
        "#FCD050",
        "#FCC937",
        "#edb40d",
        "#FBBF11",
        "#EEB305",
        "#E2A905",
      ],
      primary: "#edb40d",
    },
    primaryColor: "brand",
  });
  const [colorScheme, setColorScheme] = useLocalStorage({
    key: "color-scheme",
    defaultValue: "light",
  });

  useEffect(() => {
    setTheme({ colorScheme: colorScheme });
  }, [colorScheme]);

  return (
    <MantineProvider theme={theme} withGlobalStyles withNormalizeCSS>
      <ErrorBoundary>
        <NotificationsProvider>
          <ModalsProvider>
            <Router />
          </ModalsProvider>
        </NotificationsProvider>
      </ErrorBoundary>
    </MantineProvider>
  );
}

export default App;
